module.exports = __webpack_public_path__ + "img/docs.43f1a092.png";